import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/sharp-solid-svg-icons';
import React from 'react';
import './index.css';

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  pageSizeOptions?: number[];
  totalItems?: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

export function Pagination({
  currentPage,
  totalPages,
  pageSize,
  pageSizeOptions = [10, 20, 50, 100],
  totalItems,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newPageSize = Number(e.target.value);
    // Consumers reset to page 1 in their onPageSizeChange handler; also
    // calling onPageChange(1) here would fire with the stale page size.
    onPageSizeChange(newPageSize);
  };

  return (
    <div className="sc-pagination">
      <div className="sc-pagination-controls">
        <div className="sc-pagination-buttons">
          <button
            onClick={handlePrevious}
            disabled={currentPage === 1}
            className="sc-pagination-button"
            aria-label="Previous page"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <span className="sc-pagination-page">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className="sc-pagination-button"
            aria-label="Next page"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
        {totalItems !== undefined && (
          <span className="sc-pagination-total">{totalItems} items</span>
        )}
        <div style={{ height: 24, width: 1, backgroundColor: 'var(--border-subtle)' }} />
        <div className="sc-pagination-size">
          <span>Items per page</span>
          <select value={pageSize} onChange={handlePageSizeChange} className="sc-pagination-select">
            {pageSizeOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
